<template>
  <div class="page">
    <div class="goodscon">
      <div class="titlecon" v-if="inspectionDetail">
        <div class="titleleft">
          <span>分拨批次号: {{ inspectionDetail.distribution_no }}</span>
          <span v-if="inspectionDetail.add_user"
            >分拨人: {{ inspectionDetail.add_user.user_name }}</span
          >
          <span
            >分拨时间:
            {{
              $public.FTime(inspectionDetail.create_time, "YYYY-MM-DD")
            }}</span
          >

          <span>分拨数量: {{ distributionCount }}</span>

          <span
            >状态:<span
              style="color: #e6a23c"
              v-if="inspectionDetail.state == 1"
              >已验收</span
            >
            <span style="color: #13ce66" v-if="inspectionDetail.state == 2"
              >部分验收
            </span>
            <span style="color: #ff4d51" v-if="inspectionDetail.state == 3"
              >未验收
            </span></span
          >
          <span
            >实收数量:
            <strong style="color: red">{{ distributionTotalCount }}</strong>
          </span>
        </div>
        <div class="titleright">
          <el-button type="warning" @click="isBack()" size="small"
            >返回</el-button
          >
        </div>
      </div>
      <div style="font-size: 16px; margin-top: 16px">
        录入条码：
        <input
          class="el-input__inner"
          type="text"
          style="width: 200px"
          placeholder="商品条码"
          v-model.lazy="goodsCustomCode"
          @keyup.enter="search"
        />
      </div>
      <div v-for="(item, index) in sumData" :key="index">
        <div class="comH2" @click="handleShopClick(item.goods_type)">
          <div>
            {{
              item.goods_type == 1
                ? "医疗类"
                : item.goods_type == 0
                ? "商品类"
                : "耗材类"
            }}
          </div>
          <i
            v-if="showType['showType' + item.goods_type]"
            class="el-icon-caret-bottom"
          ></i>
          <i v-else class="el-icon-caret-top"></i>
        </div>
        <el-table
          default-expand-all
          row-class-name="row-expand-cove"
          :ref="'table' + item.goods_type"
          v-show="showType['showType' + item.goods_type]"
          show-summary
          :data="item.procureItem"
          style="width: 100%"
          size="small"
        >
          <el-table-column label="商品名称">
            <template slot-scope="scope">
              <span>{{ scope.row.goods.title }}</span>
            </template>
          </el-table-column>
          <el-table-column label="品牌">
            <template slot-scope="scope">
              <span>{{ scope.row.goods.brand }}</span>
            </template>
          </el-table-column>
          <el-table-column label="规格" width="140">
            <template slot-scope="scope">
              <span>{{ scope.row.goods.sku_value }}</span>
            </template>
          </el-table-column>
          <el-table-column label="单位" width="60">
            <template slot-scope="scope">
              <span>{{ scope.row.goods.unit }}</span>
            </template>
          </el-table-column>

          <el-table-column
            label="分拨数量"
            prop="distribution_count"
            width="80"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.distribution_count }}</span>
            </template>
          </el-table-column>
          <el-table-column label="有效期" prop="count" width="100">
            <template slot-scope="scope">
              <span>{{
                scope.row.distribution_datas_list.length > 1
                  ? "多效期"
                  : $public.FTime(
                      scope.row.distribution_datas_list[0].overdue_time,
                      "YYYY-MM-DD"
                    )
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="实收数量" width="100" prop="acceptance_count">
            <template slot-scope="scope">
              <span class="">{{ scope.row.acceptance_count }}</span>
            </template>
          </el-table-column>
          <el-table-column label="状态" width="80">
            <template slot-scope="scope">
              <span
                v-if="
                  scope.row.distribution_count == scope.row.acceptance_count
                "
              >
                <span style="color: #e6a23c">•</span>
                已验收
              </span>
              <span
                v-if="
                  scope.row.distribution_count > scope.row.acceptance_count &&
                  scope.row.acceptance_count != 0
                "
              >
                <span style="color: #13ce66">•</span>
                部分验收
              </span>
              <span v-if="scope.row.acceptance_count == 0">
                <span style="color: #13ce66">•</span>
                未验收
              </span>
              <span
                v-if="
                  scope.row.acceptance_info &&
                  scope.row.acceptance_info.abnormal_info &&
                  (scope.row.acceptance_info.abnormal_info.leakage_count ||
                    scope.row.acceptance_info.abnormal_info.overdue_count ||
                    scope.row.acceptance_info.abnormal_info.broken_count ||
                    scope.row.acceptance_info.abnormal_info.switch_count)
                "
              >
                <span style="color: #ff4d51">•</span>
                异常
                {{
                  scope.row.acceptance_info.abnormal_info.leakage_count +
                  scope.row.acceptance_info.abnormal_info.overdue_count +
                  scope.row.acceptance_info.abnormal_info.broken_count +
                  scope.row.acceptance_info.abnormal_info.switch_count
                }}
                <el-popover
                  popper-class="abnormalpopover"
                  placement="bottom"
                  trigger="click"
                >
                  <div class="abnormal">
                    <div>
                      漏发数量
                      {{
                        scope.row.acceptance_info.abnormal_info.leakage_count
                      }}
                    </div>
                    <div>
                      过期数量
                      {{
                        scope.row.acceptance_info.abnormal_info.overdue_count
                      }}
                    </div>
                    <div>
                      破损数量
                      {{ scope.row.acceptance_info.abnormal_info.broken_count }}
                    </div>
                    <div>
                      调换数量
                      {{ scope.row.acceptance_info.abnormal_info.switch_count }}
                    </div>
                  </div>
                  <el-button
                    slot="reference"
                    type="text"
                    icon="el-icon-view"
                  ></el-button>
                </el-popover>
              </span>
            </template>
          </el-table-column>
          <el-table-column label="验收状态" width="120">
            <template slot-scope="scope">
              <span
                v-if="
                  scope.row.distribution_count == scope.row.acceptance_count
                "
              >
                <span style="color: #e6a23c">•</span>
                已验收 {{ scope.row.acceptance_count }} /
                {{ scope.row.distribution_count }}
              </span>
              <span
                v-if="
                  scope.row.distribution_count > scope.row.acceptance_count &&
                  scope.row.acceptance_count != 0
                "
              >
                <span style="color: #13ce66">•</span>
                部分验收 {{ scope.row.acceptance_count }} /
                {{ scope.row.distribution_count }}
              </span>
              <span v-if="scope.row.acceptance_count == 0">
                <span style="color: #13ce66">•</span>
                未验收 {{ scope.row.acceptance_count }} /
                {{ scope.row.distribution_count }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="120">
            <template slot-scope="scope">
              <el-button
                type="text"
                :disabled="
                  scope.row.distribution_count == scope.row.acceptance_count
                    ? true
                    : false
                "
                @click="abnormal(scope.row, scope.$index)"
                size="small"
              >
                异常
              </el-button>
              <el-button
                type="text"
                @click="toogleExpand(scope.row)"
                size="small"
              >
                查看条码
              </el-button>
            </template>
          </el-table-column>

          <el-table-column type="expand" width="1">
            <template slot-scope="props">
              <div
                class="goodscustom"
                v-for="(item, index) in props.row.distribution_datas_list"
                :key="index"
              >
                <div>
                  有效期
                  {{ $public.FTime(item.overdue_time, "YYYY-MM-DD") }} 条码数量
                  {{ item.code_count }}
                </div>
                <div
                  style="margin-top: 10px"
                  v-if="fillterGoodsCustom(item.goods_code_list).length > 0"
                >
                  <span
                    v-for="(goodscustom, subindex) in fillterGoodsCustom(
                      item.goods_code_list
                    )"
                    :key="subindex"
                  >
                    <el-tag
                      :closable="goodscustom.goods_state == 4 ? false : true"
                      style="margin: 5px"
                      :type="
                        goodscustom.is_check || goodscustom.goods_state == 4
                          ? 'success'
                          : 'info'
                      "
                      @close="handleClose(goodscustom)"
                    >
                      <span
                        v-if="goodscustom.goods_state != 4"
                        style="color: #f56c6c"
                        >新</span
                      >
                      {{ goodscustom.code }}
                      总量 {{ goodscustom.totaltimes }}</el-tag
                    >
                  </span>
                </div>
                <div style="margin: 10px; color: #000" v-else>暂无条码数据</div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-form :model="acceptanceParam" style="margin-top: 20px">
        <el-form-item label="验货备注" label-width="80px">
          <el-input
            style="width: 300px"
            type="textarea"
            :rows="3"
            placeholder="请输入内容"
            v-model="acceptanceParam.remarks"
            size="small"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <el-dialog title="异常状态" :visible.sync="dialogVisible" width="30%">
        <div v-if="acceptItem" style="margin-bottom: 10px">
          商品名称 <span>{{ acceptItem.goods.title }}</span>
        </div>
        <div v-if="acceptItem" style="margin-bottom: 10px">
          分拨数量 <span>{{ acceptItem.distribution_count }}</span>
        </div>
        <div v-if="acceptItem" style="margin-bottom: 10px">
          实收数量 <span>{{ acceptItem.acceptance_count }}</span>
        </div>
        <div v-if="acceptdetail">
          <span>状态</span>
          <div style="margin-bottom: 10px">
            漏发数量
            <el-input-number
              size="small"
              v-model="acceptdetail.abnormal_info.leakage_count"
              :min="0"
              label="描述文字"
            ></el-input-number>
          </div>
          <div style="margin-bottom: 10px">
            过期数量
            <el-input-number
              size="small"
              v-model="acceptdetail.abnormal_info.overdue_count"
              :min="0"
              label="描述文字"
            ></el-input-number>
          </div>
          <div style="margin-bottom: 10px">
            破损数量
            <el-input-number
              size="small"
              v-model="acceptdetail.abnormal_info.broken_count"
              :min="0"
              label="描述文字"
            ></el-input-number>
          </div>
          <div style="margin-bottom: 10px">
            调换数量
            <el-input-number
              size="small"
              v-model="acceptdetail.abnormal_info.switch_count"
              :min="0"
              label="描述文字"
            ></el-input-number>
          </div>
        </div>
        <el-button type="warning" @click="sureabnormal" size="small"
          >确 定</el-button
        >
      </el-dialog>
      <div class="footer">
        <div></div>
        <div>
          <span style="margin-right: 10px"
            >验货数量
            <strong style="color: #ff0000">{{ distributionTotalCount }}</strong>
          </span>

          <el-button
            class="desc"
            :loading="loading"
            type="warning"
            @click="submiOnekey"
            size="small"
           v-if="$buttonAuthority('cangku-caigouMendian-oneKey')" >一键验收</el-button
          >
          <el-button
            class="desc"
            :loading="loading"
            type="warning"
            @click="submiAcceptance"
            size="small"
            >验货完成</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getGoodsCodeInfo } from "@/api/stockApi.js";
import { getDistributionInfo, shopAcceptance,shopAKeyAcceptance} from "@/api/shopPurchaseApi.js";
export default {
  data() {
    return {
      goodsCustomCode: "",
      showType: {
        showType0: true,
        showType1: true,
        showType7: true,
      },
      dialogVisible: false,
      sumData: [],
      inspectionDetail: {
        linkData: [],
      },
      acceptanceParam: {
        distribution_no: this.$route.query.id,
        code_list: [],
        shop_abnormal_list: [],
        remarks: "",
      },
      acceptItem: "",
      acceptdetail: "",
      loading: false,
    };
  },
  computed: {
    //计算各商品分拨总数量
    distributionCount() {
      let distributionCount = 0;
      this.inspectionDetail.linkData.forEach((item) => {
        distributionCount += item.distribution_count;
      });
      return distributionCount;
    },
    // 计算分拨总数量
    distributionTotalCount() {
      let distributionTotalCount = 0;
      this.inspectionDetail.linkData.forEach((item) => {
        distributionTotalCount += item.acceptance_count;
      });

      return distributionTotalCount;
    },
  },
  methods: {
    fillterGoodsCustom(arry) {
      let custtomList = arry.filter((item) => {
        return item.is_check == true || item.goods_state == 4;
      });

      return custtomList;
    },
    getDistributionInfo(id) {
      getDistributionInfo({
        distribution_no: id,
      }).then((res) => {
        if (res.code == 0) {
          this.inspectionDetail = res.data;
          this.sumData = this.sumGoods(res.data.linkData);
          console.log(this.sumData, this.inspectionDetail);
          this.acceptanceParam.remarks = res.data.remarks;
        }
      });
    },
    sumGoods(arry) {
      let sumData = [];

      arry.forEach((item) => {
        let index = sumData.findIndex((ele) => {
          return item.goods.goods_type == ele.goods_type;
        });

        if (index == -1) {
          sumData.push({
            goods_type: item.goods.goods_type,
            procureItem: [item],
          });
        } else {
          sumData[index].procureItem.push(item);
        }
      });
      return sumData;
    },
    submiAcceptance() {
      this.loading = true;
      shopAcceptance(this.acceptanceParam).then((res) => {
        if (res.code == 0) {
          this.loading = false;
          this.$router.push({
            path: "/caigoumendian/shopPurchase",
            query: {
              tabs: 2,
            },
          });
        } else {
          this.loading = false;
        }
      });
    },
    // 一键验收
    submiOnekey(){
      this.loading = true;
      console.log(this.inspectionDetail.company_info.shop_id,'this.inspectionDetail');
      let params={
        distribution_no:this.acceptanceParam.distribution_no,
        isDistribution:false,
        toShopId:this.inspectionDetail.company_info.shop_id
      }
      shopAKeyAcceptance(params).then((res) => {
        if (res.code == 0) {
          this.loading = false;
          this.$message.error("已全部验收成功");
        }
      });
    },
    handleShopClick(type) {
      this.showType["showType" + type] = !this.showType["showType" + type];
    },
    toogleExpand(row) {
      let $table = this.$refs["table" + row.goods.goods_type][0];
      $table.toggleRowExpansion(row);
    },
    search() {
      let params = {
        customCode: this.goodsCustomCode,
      };
      getGoodsCodeInfo(params).then((res) => {
        if (res.code == 0) {
          let isFound = false;
          let isRepeat;
          let isacept = false;
          //判断是否重复
          isRepeat = this.acceptanceParam.code_list.some((item) => {
            return item == res.data.customCode;
          });

          if (isRepeat) {
            this.$message.error("条码重复");
            this.goodsCustomCode = "";
          } else {
            //判断是否找到
            this.sumData.forEach((item) => {
              item.procureItem.forEach((ele) => {
                ele.distribution_datas_list.forEach((goodsele) => {
                  goodsele.goods_code_list.forEach((goodscustom) => {
                    if (
                      goodscustom.code == res.data.customCode &&
                      goodscustom.goods_state != 4
                    ) {
                      goodscustom.is_check = true;
                      isFound = true;
                      this.acceptanceParam.code_list.push(res.data.customCode);
                      ele.acceptance_count += 1;
                      this.goodsCustomCode = "";
                      return;
                    }
                    if (
                      goodscustom.code == res.data.customCode &&
                      goodscustom.goods_state == 4
                    ) {
                      console.log();
                      isacept = true;
                      isFound = true;
                      this.goodsCustomCode = "";
                      return;
                    }
                  });
                });
              });
            });
            if (isacept) {
              this.$message.error("此条码已验货");
              this.goodsCustomCode = "";
            }
            if (!isFound) {
              this.$message.error(
                "该验货单中未匹配到此条码,就是说这个验货单中没有分配给你这个条码，要么你扫错商品了，要么送错了," +
                  "此条码状态为" +
                  res.data.customCodeStatus.name
              );
              this.goodsCustomCode = "";
            }
          }
        }
      });
    },
    //异常数据
    abnormal(row, index) {
      console.log(index, row);
      this.dialogVisible = true;
      this.acceptItem = row;
      this.acceptdetail = {
        procure_goods_id: row.procure_goods_id,
        abnormal_info: {
          leakage_count:
            row.acceptance_info && row.acceptance_info.abnormal_info
              ? row.acceptance_info.abnormal_info.leakage_count
              : 0,
          overdue_count:
            row.acceptance_info && row.acceptance_info.abnormal_info
              ? row.acceptance_info.abnormal_info.overdue_count
              : 0,
          broken_count:
            row.acceptance_info && row.acceptance_info.abnormal_info
              ? row.acceptance_info.abnormal_info.broken_count
              : 0,
          switch_count:
            row.acceptance_info && row.acceptance_info.abnormal_info
              ? row.acceptance_info.abnormal_info.switch_count
              : 0,
        },
      };
    },
    //确定
    sureabnormal() {
      let inspecCount =
        this.acceptItem.acceptance_count +
        this.acceptdetail.abnormal_info.leakage_count +
        this.acceptdetail.abnormal_info.overdue_count +
        this.acceptdetail.abnormal_info.broken_count +
        this.acceptdetail.abnormal_info.switch_count;
      if (this.acceptItem.distribution_count < inspecCount) {
        this.$message.error("实收数量和异常数量之和，已经大于分拨数量了");
      } else {
        this.acceptItem["acceptance_info"] = {};
        this.acceptItem["acceptance_info"]["abnormal_info"] =
          this.acceptdetail.abnormal_info;
        console.log(this.acceptItem);
        this.acceptanceParam.shop_abnormal_list.push(this.acceptdetail);
        this.dialogVisible = false;
      }
      // console.log(this.acceptItem,inspecCount)
    },
    isBack() {
      this.$alert("你正在验货,返回数据将不会保存,确认返回", "确认返回", {
        confirmButtonText: "确定",
        callback: (action) => {
          if (action == "confirm") {
            if (this.$route.query.refer) {
              this.$router.back();
            } else {
              this.$router.push({
                path: "/caigoumendian/shopPurchase",
                query: {
                  tabs: 2,
                },
              });
            }
          } else {
            this.$message({
              type: "info",
              message: "取消返回",
            });
          }
        },
      });
    },
    handleClose(goodscustom) {
      //删除提交的条码数据 隐藏条码验收状态，并改变验货实收数量
      let index = this.acceptanceParam.code_list.indexOf(
        goodscustom.code.toString()
      );
      goodscustom.is_check = false;
      this.acceptanceParam.code_list.splice(index, 1);
      this.sumData.forEach((item) => {
        item.procureItem.forEach((ele) => {
          if (
            goodscustom.goodsid == ele.goods._id &&
            goodscustom.skusid == ele.goods.sku_id
          ) {
            ele.acceptance_count -= 1;
            return;
          }
        });
      });
    },
  },
  created() {
    this.getDistributionInfo(this.$route.query.id);
  },
};
</script>

<style lang="scss">
.titlecon {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 1;
  background-color: #fff;
  margin-bottom: 10px;
  .titleleft {
    span {
      margin: 10px 20px;
      display: inline-block;
    }
  }

  .titleright {
    margin-right: 20px;
    // margin-top: 20px;
  }
}

.comH2 {
  line-height: 50px;
  font-size: 16px;
  display: flex;
  align-items: center;
}

.abnormalpopover {
  background-color: #000000;
  color: #fff;
}

.row-expand-cove .el-table__expand-icon {
  display: none;
}

.footer {
  background-color: #f5f5f5;
  position: fixed;
  bottom: 0;
  height: 50px;
  line-height: 50px;
  display: flex;
  justify-content: space-between;
  left: 220px;
  right: 0;
  padding-left: 20px;
  z-index: 200;

  .desc {
    margin-right: 20px;
  }
}
</style>
